import {createAction, createReducer} from 'redux-act';
import {ApplicationStoreType} from 'reducers';
import {getContactsPdp} from 'features/contacts/selectors/contacts/contacts';

type BoxOptionType = string;

/**
 * List of actions
 */
export const setBoxOption = createAction<BoxOptionType>('CONTACTS_WIZARD_SET_BOX_OPTION');

/**
 * Box option reducer
 */
export const selectedBoxOption = createReducer({}, '').on(setBoxOption, (_, payload) => payload);

/**
 * Get name of CL box options for Analytics
 * @param {ApplicationStoreType} store - redux store
 * @returns {string} name of CL box options for Analytics
 */
export const getSelectedBoxOption = (store: ApplicationStoreType): string =>
    getContactsPdp(store).selectedBoxOption;
